module.exports = __webpack_public_path__ + "img/undraw_map.3c1135f2.svg";